import { Suspense } from "react";
import PillarStockholm from "./PillarStockholm";
import PillarSanFrancisco from "./PillarSanFrancisco";
import { useAppStore } from "@/stores/appStore";
import { useContent } from "@/hooks/useContent";
import DoorHinge from "../Hinges/DoorHinge";

//Interfaces
import { PillarProps } from "@/services/interfaces";

export default function Pillar({ doorWidth, outerHeight, pillarPosition }: PillarProps) {
	const { getPillars } = useContent();
	const { pillar } = useAppStore((state) => state.configurator);
	const currentPillar = getPillars().find((x) => x.id === pillar.id);

	return (
		<group>
			<DoorHinge
				pillarPosition={pillarPosition}
				position={[doorWidth - 0.005, outerHeight / 5, -0.015]}
				rotation={[Math.PI, 0, 0]}
			/>
			<DoorHinge
				pillarPosition={pillarPosition}
				position={[doorWidth - 0.005, outerHeight - outerHeight / 5, -0.015]}
				rotation={[Math.PI, 0, 0]}
			/>

			{currentPillar?.id === "pillar_stockholm" && (
				<PillarStockholm
					doorWidth={doorWidth}
					outerHeight={outerHeight}
					pillarDimensions={pillar.selectedDimensions}
					pillarPosition={pillarPosition}
				/>
			)}
			{currentPillar?.id === "pillar_sanfrancisco" && (
				<PillarSanFrancisco
					id={"pillar_sanfrancisco"}
					doorWidth={doorWidth}
					outerHeight={outerHeight}
					pillarDimensions={pillar.selectedDimensions}
					pillarPosition={pillarPosition}
				/>
			)}
		</group>
	);
}
